export enum CommissionType {
    UNKNOWN = 0,
    NO_CLIENT_COMMISSION = 1
}
